import { TAdFoxBannerSizeProps } from '@cian/adfox-component';
import { TBannerType } from '../../../../types/banner';

const BANNER_SIZE_MAP = new Map<TBannerType, TAdFoxBannerSizeProps>([
  ['aside', { width: '100%', height: 100 }],
  ['listing', { width: '100%', height: 20 }],
]);

export const getBannerSize = (type: TBannerType) => {
  return BANNER_SIZE_MAP.get(type) as TAdFoxBannerSizeProps;
};
